"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLink = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
exports.StyledLink = styled_components_1.default.a `
  cursor: pointer;
  &:hover {
    color: ${monera_app_core_1.rioTextColors.linkHover};
    cursor: pointer;
    text-decoration: none;
  }
`;
